@for (option of options(); track option.value) {
  <button
    type="button"
    role="option"
    tabindex="-1"
    [id]="optionId(option.value)"
    [value]="option.value"
    [attr.aria-selected]="option.value === value()"
    [disabled]="option.disabled"
    (click)="selectOption(option)"
  >
    {{ option.label }}
  </button>
}
